import React from 'react';
import { AppControlledSwitch } from '../app/input/appControlledSwitch';
import { Grid, Paper, Tooltip, Typography } from '@mui/material';

const style = {
  paper: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '5px',
    width: 255,
    height: 82,
  },
  userTooltip: {
    ml: 2,
    display: '-webkit-box',
    ' -webkit-box-orient': 'vertical',
    ' -webkit-line-clamp': 3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  },
} as const;

export interface UserBoxProp {
  label: string;
  name: string;
  switchStyle?: 'switchType' | 'normal';
  defaultValue?: boolean;
}

export default function UserBox({
  label,
  name,
  defaultValue,
}: UserBoxProp): JSX.Element {
  return (
    <Grid
      container
      sx={{ paddingX: 1, paddingY: 1 }}
      item
      xs={6}
      justifyContent="flex-start"
      alignItems="center"
    >
      <Paper elevation={3} sx={style.paper}>
        <Grid item={true} xs={8} alignItems="center">
          <Tooltip title={label} placement="top-start">
            <Typography sx={style.userTooltip}>{label}</Typography>
          </Tooltip>
        </Grid>
        <Grid item={true} xs={2} alignItems="center">
          <AppControlledSwitch
            name={name}
            defaultValue={
              typeof defaultValue === 'undefined' ? true : defaultValue
            }
          />
        </Grid>
      </Paper>
    </Grid>
  );
}
